"use client"

import { Settings } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { DialogHelper } from "@/components/dialog-helper"
import { ToggleTheme } from "@/components/toggle-theme"

export function ConfigSetting() {
  return (
    <DialogHelper
      trigger={
        <div className="fixed right-0 top-1/2 z-30 rounded-full">
          <Button size="icon" className="rounded-full">
            <Settings className="animate-spin" />
          </Button>
        </div>
      }
      title="Config Setting"
      description="Change the configuration settings"
      className="max-w-lg"
    >
      <div className="space-y-2">
        <Label>Theme Mode</Label>
        <ToggleTheme />
      </div>
    </DialogHelper>
  )
}
